import { isImageFile } from '@/lib/isImageFIle'
import { Box, Container, Heading, SimpleGrid } from '@chakra-ui/react'
import React from 'react'
import { Gallery, Item } from 'react-photoswipe-gallery'
import 'photoswipe/dist/photoswipe.css'

type StatamicImage = {
  url: string
  width: number
  height: number
  id: string
}

type GalleryBlockProps = {
  gallery_title?: string
  gallery_images?: StatamicImage[]
}

export const GalleryBlock: React.FC<GalleryBlockProps> = props => {
  return (
    <>
      <Container maxWidth='6xl' textAlign='center'>
        <Heading as='h2' mb={8}>
          {props.gallery_title}
        </Heading>
        <Container maxW='6xl'>
          <Gallery>
            <SimpleGrid columns={{ base: 1, md: 2, xl: 3 }} spacing={4}>
              {props.gallery_images &&
                props.gallery_images.map(
                  image =>
                    isImageFile(image.url) && (
                      <Item
                        id={image.id}
                        original={image.url}
                        thumbnail={image.url}
                        width={image.width}
                        height={image.height}
                        caption=''
                        key={image.id}
                        cropped>
                        {({ ref, open }) => (
                          // @ts-ignore-next-line no-legacy-refs
                          <Box ref={ref} onClick={open} position='relative'>
                            <img
                              src={image.url}
                              alt=''
                              style={{ objectFit: 'cover' }}
                              width={image.width}
                              height={image.height}
                            />
                          </Box>
                        )}
                      </Item>
                    )
                )}
            </SimpleGrid>
          </Gallery>
        </Container>
      </Container>
    </>
  )
}

export default GalleryBlock
